import script from "./CompactItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompactItem.vue?vue&type=script&lang=ts&setup=true"

import "./CompactItem.vue?vue&type=style&index=0&id=cf2d584a&lang=scss"

const __exports__ = script;

export default __exports__